import {
    BillingPayMethodsKey,
    BillingPayMethodsKeyType,
    ChargeBenefitPointRate,
    PaymentGatewayCodeType,
} from '@web/core/constants'
import {
    selectedEasyBankAccountSelector,
    selectedEasyCardSelector,
    selectedPaymentMobileSelector,
    selectedWithdrawalAccountSelector,
} from '@web/slices/priorityPaymentMethod/slice'

export type ReturnedPaymentGatewayFieldsSelector = {
    pgcd: PaymentGatewayCodeType | ''
    pgid: string
    /** 충전결제인 경우 'C' */
    chargeType?: 'C'
    corpcd: string
    productCd: string
    payno: string
    corpkey: string
}

export const getRegisterPaymentGatewayParams = (
    billingPayMethod: BillingPayMethodsKeyType,
    origin: {pgcd: PaymentGatewayCodeType | ''; pgid: string},
    selectedPayment: {
        account?: ReturnType<typeof selectedEasyBankAccountSelector>
        card?: ReturnType<typeof selectedEasyCardSelector>
        withdrawalAccount?: ReturnType<typeof selectedWithdrawalAccountSelector>
        mobile?: ReturnType<typeof selectedPaymentMobileSelector>
    },
): ReturnedPaymentGatewayFieldsSelector => {
    if (billingPayMethod === BillingPayMethodsKey.BANK_EASY_PAY) {
        return {
            ...origin,
            corpcd: selectedPayment.account?.bankCode ?? '',
            productCd: selectedPayment.account?.payPartnershipItemCode ?? '',
            payno: selectedPayment.account?.maskedAccountNumber ?? '',
            corpkey: selectedPayment.account?.accountKey ?? '',
        }
    } else if (billingPayMethod === BillingPayMethodsKey.CARD_EASY_PAY) {
        return {
            ...origin,
            corpcd: selectedPayment.card?.cardCompanyId ?? '',
            productCd: selectedPayment.card?.cardProductCode ?? '',
            payno: selectedPayment.card?.maskedCardNumber ?? '',
            corpkey: selectedPayment.card?.cardId ?? '',
        }
    } else if (billingPayMethod === BillingPayMethodsKey.RECHARGE_POINT) {
        return {
            ...origin,
            chargeType: 'C',
            corpcd: selectedPayment.withdrawalAccount?.code ?? '',
            productCd: selectedPayment.withdrawalAccount?.partnershipCode ?? '',
            payno: selectedPayment.withdrawalAccount?.number ?? '',
            corpkey: selectedPayment.withdrawalAccount?.id ?? '',
        }
    } else {
        return {
            ...origin,
            corpcd: '000',
            productCd: '',
            payno: selectedPayment.mobile?.mobileNumbers ?? '',
            corpkey: '',
        }
    }
}

interface GetAccumulateTypeParams {
    isBooking: boolean
    hasWithdrawalAccount: boolean
    isPayMoneyUser: boolean
    naverBankbookSelected: boolean
}

export const getAccumulateType = ({
    isBooking,
    hasWithdrawalAccount,
    isPayMoneyUser,
    naverBankbookSelected,
}: GetAccumulateTypeParams) => {
    /**
     * @check
     * - 디컨정기의 경우 현재 스펙 기준 > 고정 3%로 노출
     * - 추후 충전결제 적립률 API 연동시 서버 응답값 활용 예정
     */
    // if (isDiconAuto) {
    //     if (hasWithdrawalAccount && !naverBankbookSelected && !isPayMoneyUser) {
    //         return ChargeBenefitPointRate.TWO_HALF_MAX
    //     }
    // }
    if (isBooking) {
        if (hasWithdrawalAccount) {
            if (naverBankbookSelected || isPayMoneyUser) {
                return ChargeBenefitPointRate.THREE
            } else {
                return ChargeBenefitPointRate.TWO_HALF
            }
        }
    }
    return ChargeBenefitPointRate.MAX
}
